import { FC } from 'react';
import { Modal } from '@spotnana/blocks/src/Modal';
import { Typography } from '@spotnana/blocks/src/Typography';
import { useTranslation } from 'react-i18next';
import { Button } from '@spotnana/blocks/src/Button';
import { FareList } from 'obt-common';
import { SavedFareList } from '../SavedFareList';
import { modal_secondary_background } from '../shared/styles';

export interface IProps {
  open: boolean;
  onClose: VoidFunction;
  /**
   * Lists rendered through this component should only be the ones that belong to the traveler that is being booked.
   * So agent cannot add itineraries to lists that do not belong to the traveler.
   */
  fareList: FareList[];
  onAddToExistingList: (listId: string) => void;
  onCreateNewList: VoidFunction;
}
export const AddToShareItineraryListModal: FC<IProps> = ({
  fareList,
  onAddToExistingList,
  onClose,
  open,
  onCreateNewList,
}) => {
  const { t: tt } = useTranslation('WEB');

  return (
    <Modal
      open={open}
      onClose={onClose}
      header={{ title: tt('Add to itinerary list') }}
      footer={{
        content: (
          <Button onClick={onCreateNewList} startIcon="AddPlus" fullWidth>
            {tt('Create new list')}
          </Button>
        ),
      }}
      variant="medium"
      css={modal_secondary_background}
    >
      <div>
        {fareList.length === 0 ? (
          <Typography variant="body1" color="secondary">
            {tt(
              'No saved itineraries found. Please create a new list. You can add multiple itineraries to the list and share them with the traveler(s).',
            )}
          </Typography>
        ) : (
          <SavedFareList fareList={fareList} onClick={onAddToExistingList} onClose={onClose} />
        )}
      </div>
    </Modal>
  );
};
